module.exports = __webpack_public_path__ + "static/jigyo1-0889591ff064d534852f3aac9f2a17f5.jpg";